import * as React from 'react';
import { cx } from 'linaria';

import { Portal, useTheme } from '../index';

import * as styles from './alert.styles';
import { AlertItem } from './alert-item';
import { AlertActions } from './alert-actions';

export const AlertContext = React.createContext<AlertProps>(null);

export interface AlertProps {
    inline?: boolean;
    dark?: boolean;
    dangerouslySetClassName?: string;
}

interface AlertComposition {
    Item: typeof AlertItem;
    Actions: typeof AlertActions;
}

type AlertComponent = React.ForwardRefExoticComponent<
    React.PropsWithChildren<AlertProps> & React.RefAttributes<HTMLDivElement>
> &
    Partial<AlertComposition>;

export const Alert: AlertComponent = React.forwardRef<HTMLDivElement, React.PropsWithChildren<AlertProps>>(
    (props, ref) => {
        const theme = useTheme();
        const { inline, dangerouslySetClassName, children, dark = theme === 'dark' } = props;

        const PortalComponent = inline ? React.Fragment : Portal;
        return children ? (
            <AlertContext.Provider value={{ ...props, dark }}>
                <PortalComponent>
                    <div ref={ref} className={cx(!inline && styles.rootFixed, dangerouslySetClassName)}>
                        {children}
                    </div>
                </PortalComponent>
            </AlertContext.Provider>
        ) : null;
    },
);
Alert.displayName = 'Alert';

export default Alert;
